import React, { useState } from "react";
import { LuChevronDown } from "react-icons/lu";
const AccordionItem = ({ title = "", headers = [], data = [] }) => {
  const [isOpen, setIsOpen] = useState(true);

  return (
    <div className="tw-w-full tw-break-words">
      {title && (
        <div>
          <button
            type="button"
            aria-expanded={isOpen}
            className="tw-flex tw-min-h-11 tw-w-full tw-cursor-pointer tw-items-center tw-justify-between tw-rounded-lg tw-border-0 tw-border-l-[3px] tw-border-solid tw-border-l-dis-sky tw-bg-dis-sky-tint tw-px-3 tw-text-left tw-text-dis-navy"
            onClick={() => setIsOpen(!isOpen)}
          >
            <span className="tw-text-base tw-font-semibold">{title}</span>
            <LuChevronDown
              aria-hidden="true"
              className={`tw-h-5 tw-w-5 tw-text-dis-deep-blue tw-transition-transform ${isOpen ? "tw-rotate-180" : ""}`}
            />
          </button>
          {isOpen && (
            <div className="tw-mt-1">
              {headers.map((header, index) => (
                <div key={index} className="tw-flex tw-w-full tw-items-start tw-justify-between tw-gap-3 tw-border-x-0 tw-border-t-0 tw-border-b tw-border-solid tw-border-dis-divider tw-px-2.5 tw-py-3 tw-text-base tw-leading-[1.4] tw-text-dis-text-2 last:tw-border-b-0">
                  <span>{header}</span>
                  <span className="tw-shrink-0 tw-font-semibold tw-text-dis-navy">{data[index]}</span>
                </div>
              ))}
            </div>
          )}
        </div>
      )}
    </div>
  );
};

const PaymentsAccordion = ({ title = "", headers = [], data = [] }) => {
  return (
    <div>
      <AccordionItem headers={headers} data={data} title={title} />
    </div>
  );
};

export default PaymentsAccordion;
